// apilinks.js
const ApiLinks = {
  // ── Auth ────────────────────────────────────────────────
  login: "superadmin/auth/login",
  logout: "superadmin/auth/logout",

  // ── User ─────────────────────────────────────────────────
  User_UpdateWebFcm: (id) => `User/${id}/web-fcm`, // PATCH /User/{id}/web-fcm

  // ── Courses ─────────────────────────────────────────────
  Courses_GetAll: "courses",                                        // GET    /courses
  Courses_GetById: (id) => `courses/${id}`,                          // GET    /courses/{id}
  Courses_Save: "courses",                                           // POST   /courses
  Courses_Update: (id) => `courses/${id}`,                           // PUT    /courses/{id}
  Courses_Delete: (id, userId) => `courses/${id}?userId=${userId}`,  // DELETE /courses/{id}
  Courses_GetByUniversity: (uniId) => `courses/university/${uniId}`, // GET    /courses/university/{universityId}

  // ── Departments ─────────────────────────────────------
  Departments_GetAll: "departments",                         // GET    /departments
  Departments_GetById: (id) => `departments/${id}`,          // GET    /departments/{id}
  Departments_Save: "departments",                           // POST   /departments
  Departments_Update: (id) => `departments/${id}`,           // PUT    /departments/{id}
  Departments_Delete: (id, userId) => `departments/${id}?userId=${userId}`,  // DELETE /departments/{id}

  // ── Universities ───────────────────────────────────────
  Universities_GetAll: "universities",                         // GET    /universities
  Universities_GetById: (id) => `universities/${id}`,          // GET    /universities/{id}
  Universities_Save: "universities",                           // POST   /universities
  Universities_Update: (id) => `universities/${id}`,           // PUT    /universities/{id}
  Universities_Delete: (id, userId) => `universities/${id}?userId=${userId}`,  // DELETE /universities/{id}
  Universities_Dropdown: (role) => `universities/dropdown?for_role=${role}`,  // GET    /universities/dropdown?for_role={role}

  // ── Majors ───────────────────────────────────────────
  Majors_GetAll: "majors",                                          // GET    /majors
  Majors_GetById: (id) => `majors/${id}`,                           // GET    /majors/{id}
  Majors_Save: "majors",                                            // POST   /majors
  Majors_Update: (id) => `majors/${id}`,                            // PUT    /majors/{id}
  Majors_Delete: (id, userId) => `majors/${id}?userId=${userId}`,  // DELETE /majors/{id}
  Majors_GetByUniversity: (uniId) => `majors/university/${uniId}`,  // GET    /majors/university/{universityId}

  // ── Audit Logs ────────────────────────────────────────
  AuditLogs_GetAll: "audit-logs",                                // GET  /audit-logs
  AuditLogs_GetByUser: (userId) => `audit-logs/user/${userId}`,  // GET  /audit-logs/user/{userId}

  // ── User Menu Permissions ─────────────────────────────
  UserPermissions_GetMenus: "user-menu-permissions/menus",                            // GET  /user-menu-permissions/menus
  UserPermissions_GetByAdmin: (userId) => `user-menu-permissions/user/${userId}`,      // GET  /user-menu-permissions/user/{userId}
  UserPermissions_BulkSave: (userId) => `user-menu-permissions/bulk/${userId}`,        // POST /user-menu-permissions/bulk/{userId}

  // ── Community Category ────────────────────────────────
  CommunityCategory_GetAll: "CommunityCategory",                          // GET    /CommunityCategory
  CommunityCategory_GetById: (id) => `CommunityCategory/${id}`,           // GET    /CommunityCategory/{id}
  CommunityCategory_Save: "CommunityCategory",                            // POST   /CommunityCategory
  CommunityCategory_Update: "CommunityCategory",                          // PUT    /CommunityCategory
  CommunityCategory_Delete: (id, userId) => `CommunityCategory/${id}?userId=${userId}`,  // DELETE /CommunityCategory/{id}

  // ── Community ─────────────────────────────────────────
  Community_GetAll: "Community",                                          // GET    /Community
  Community_GetById: (id) => `Community/${id}`,                           // GET    /Community/{id}
  Community_Save: "Community",                                            // POST   /Community
  Community_Update: (id) => `Community/${id}`,                            // PUT    /Community/{id}
  Community_Delete: (id, userId) => `Community/${id}?userId=${userId}`,   // DELETE /Community/{id}

  // ── File Upload ───────────────────────────────────────
  FileUpload_UploadImage: (folderName) => `FileUpload/UploadImage/${folderName}`,  // POST  /FileUpload/UploadImage/{folderName}
  FileUpload_GetSpacesUploadUrl: (filename, mediaType, folderName) => `FileUpload/spaces/upload-url?filename=${encodeURIComponent(filename)}&mediaType=${encodeURIComponent(mediaType)}&folderName=${encodeURIComponent(folderName)}`,  // GET  /FileUpload/spaces/upload-url
  FileUpload_MakePublic: "FileUpload/spaces/make-public",  // POST /FileUpload/spaces/make-public

  // ── User Roles ────────────────────────────────────────
  UserRoles_GetAdmins: "user-roles",                                      // GET    /user-roles

  // ── UniAdmin Profiles ─────────────────────────────────
  UniAdminProfiles_Create: "uniadmin-profiles/create",  // POST /api/v1/uniadmin-profiles/create
  UniAdminProfiles_GetAll: "uniadmin-profiles",         // GET  /api/v1/uniadmin-profiles

  // ── Counsellor ────────────────────────────────────────
  Counsellor_Create: "counsellor/auth/create",                           // POST   /api/v1/counsellor/auth/create
  CounsellorMasters_GetByType: (type) => `counsellor-masters/${type}`,   // GET    /api/v1/counsellor-masters/{type}
  // ── User ────────────────────────────────────────────────
  User_GetAll: "User",                                                       // GET    /api/v1/User

  // ── SuperAdmin (User List) ────────────────────────────
  SuperAdmin_GetAll: "superadmin",                                          // GET    /superadmin
  SuperAdmin_Save: "superadmin",                                            // POST   /superadmin
  SuperAdmin_GetById: (id) => `superadmin/${id}`,                           // GET    /superadmin/{userId}
  SuperAdmin_Update: (id) => `superadmin/${id}`,                            // PUT    /superadmin/{userId}
  SuperAdmin_Delete: (id, deletedByUserId) => `superadmin/${id}?deletedByUserId=${deletedByUserId}`,  // DELETE /superadmin/{userId}
  SuperAdmin_GetByRole: (role) => `superadmin/role/${role}`,                // GET    /superadmin/role/{userRole}

  // ── Explore Item ─────────────────────────────────────
  ExploreItem_GetAll: "ExploreItem",                                                  // GET    /api/v1/ExploreItem
  ExploreItem_Save: "ExploreItem",                                                    // POST   /api/v1/ExploreItem
  ExploreItem_Update: (id) => `ExploreItem/${id}`,                                    // PUT    /api/v1/ExploreItem/{id}
  ExploreItem_Delete: (id) => `ExploreItem/${id}`,                                    // DELETE /api/v1/ExploreItem/{id}

  // ── Student Profiles ─────────────────────────────────
  StudentProfile_GetAll: "student-profiles",              // GET  /student-profiles
  StudentProfile_Save: "student-profiles",                // POST /student-profiles

  // ── University Requests ───────────────────────────────
  UniversityRequests_GetAll: "university-requests",              // GET   /api/v1/university-requests
  UniversityRequests_BulkNotify: "university-requests/bulk-notify", // PATCH /api/v1/university-requests/bulk-notify

  // ── Post Moderation ───────────────────────────────────
  PostModeration_GetFlagged: (minPercent) => `PostModeration/flagged-posts?min_percent=${minPercent}`,  // GET   /api/v1/PostModeration/flagged-posts
  PostModeration_GetFlaggedComments: (minPercent) => `PostModeration/flagged-comments?min_percent=${minPercent}`, // GET /api/v1/PostModeration/flagged-comments
  PostModeration_ApprovePost: (postId) => `PostModeration/posts/${postId}/approve`,         // PATCH /api/v1/PostModeration/posts/{postId}/approve
  PostModeration_ApproveComment: (commentId) => `PostModeration/comments/${commentId}/approve`, // PATCH /api/v1/PostModeration/comments/{commentId}/approve

  // ── Post ──────────────────────────────────────────────
  Post_GetAll: (userId, status, moderationStatus, page = 1, pageSize = 20) => `CommunityPost/all?requestingUserId=${userId}&status=${status}${moderationStatus ? `&moderationStatus=${moderationStatus}` : ""}&page=${page}&pageSize=${pageSize}`, // GET    /api/v1/CommunityPost/all
  Post_Save: "CommunityPost",                                                         // POST   /api/v1/CommunityPost
  Post_GetById: (id) => `CommunityPost/${id}`,                                        // GET    /api/v1/CommunityPost/{id}
  Post_Update: (id) => `CommunityPost/${id}`,                                         // PUT    /api/v1/CommunityPost/{id}
  Post_Delete: (id, userId) => `CommunityPost/${id}?userId=${userId}`,                 // DELETE /api/v1/CommunityPost/{id}
  Post_SetStatus: (id, adminId, status) => `CommunityPost/${id}/status?adminId=${adminId}&status=${status}`, // PATCH  /api/v1/CommunityPost/{id}/status
  Post_Block: (blockerId, blockedId) => `CommunityPost/block?blockerId=${blockerId}&blockedId=${blockedId}`,  // POST   /api/v1/CommunityPost/block
};

export default ApiLinks;
